const KIND_LABELS = {
  sequence: "Sequence",
  selector: "Fallback",
  retry: "Retry",
  repeat: "Repeat",
  ifThenElse: "If / Then / Else",
  servoPickPlace: "Pick & Place Servo",
  moveEeToXyz: "Move EE → XYZ",
  moveEeByOffset: "Move EE Offset",
  runTrainedModel: "Trained Model",
  openGripper: "Open Gripper",
  closeGripper: "Close Gripper",
  goToKeyframe: "Go To Keyframe",
  wait: "Wait",
  randomizeObjectPose: "Randomize Object",
  setObjectPose: "Set Object Pose",
  resetToBaseline: "Reset Baseline",
  markSuccess: "Mark Success",
  markFailure: "Mark Failure",
  conditionObjectGrasped: "Condition · Object Lifted",
  conditionEeNear: "Condition · EE Near Point",
  conditionObjectNear: "Condition · Object Near Point",
  conditionTimeElapsed: "Condition · Time Elapsed",
};

const CATEGORY_COLORS = {
  composite: "#a78bfa",
  motion: "#60a5fa",
  gripper: "#0ea5e9",
  scene: "#34d399",
  condition: "#22c55e",
  episode: "#facc15",
  default: "#9ca3af",
};

function getCategory(kind) {
  if (
    kind === "sequence" ||
    kind === "selector" ||
    kind === "retry" ||
    kind === "repeat" ||
    kind === "ifThenElse"
  )
    return "composite";
  if (
    kind === "moveEeToXyz" ||
    kind === "moveEeByOffset" ||
    kind === "goToKeyframe" ||
    kind === "servoPickPlace" ||
    kind === "runTrainedModel"
  )
    return "motion";
  if (kind === "openGripper" || kind === "closeGripper") return "gripper";
  if (
    kind === "randomizeObjectPose" ||
    kind === "setObjectPose" ||
    kind === "resetToBaseline" ||
    kind === "wait"
  )
    return "scene";
  if (
    kind === "conditionObjectGrasped" ||
    kind === "conditionEeNear" ||
    kind === "conditionObjectNear" ||
    kind === "conditionTimeElapsed"
  )
    return "condition";
  if (kind === "markSuccess" || kind === "markFailure") return "episode";
  return "default";
}

export { CATEGORY_COLORS, KIND_LABELS, getCategory };
